<template>
  <div class="newsletter-container">
    <ValidationObserver v-slot="{ handleSubmit }" slim>
      <form @submit.prevent.stop="handleSubmit(doSubscribe)">
          <ValidationProvider
            :name="$t('Email address')"
            rules="required|email"
            :skip-if-empty="false"
            v-slot="{ errors, classes }"
            tag="div"
            class="newsletter__input">
            <input type="email" v-model="email" :placeholder="$t('Your Email address')" :class="classes"/>
            <span class="field-error">{{ $t(errors[0]) }}</span>
            <span :class="success ? 'field-success' : 'field-error'" v-show="null !== success">{{ message }}</span>
          </ValidationProvider>
          <button type="submit" class="_button" :disabled="isLoading"></button>
      </form>
    </ValidationObserver>
  </div>
</template>

<script lang="ts">
  import {Component, Vue} from 'vue-property-decorator';
  import {apiClient} from '../shared/services/api-client';
  import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
  import {email, required} from 'vee-validate/dist/rules';

  extend('required', required);
  extend('email', email);

  @Component({
    name: 'footer-subscribe',
    components: {
      ValidationProvider,
      ValidationObserver
    }
  })

  export default class extends Vue {
    private email: string = '';
    private message: string = '';
    private success: string | null = null;
    private isLoading: boolean = false;

    private async doSubscribe() {
      this.isLoading = true;
      try {
        const {data} = await apiClient.post(`/rest/V1/newsletter/subscribe`, {email: this.email});
        this.message = data.message;
        this.success = data.success;
      } catch (e) {
        this.email = '';
      } finally {
        this.isLoading = false;
        setTimeout(() => {
          this.message = '';
          this.success = null;
        }, 4000);
      }
    }
  }
</script>
